import { useEffect, useState } from 'react'
import api from 'common/services/api'
import { PricesList } from '../types'

/**
 * Plan pricing from the server. One call returns every annual plan; the 12-week sprint list is a
 * separate call and is only fetched when a visible plan offers that term.
 */
export default function usePrices(enabled: boolean, withSprint: boolean) {
  const [annualPrices, setAnnualPrices] = useState<PricesList | null>(null)
  const [sprintPrices, setSprintPrices] = useState<PricesList | null>(null)

  useEffect(() => {
    if (!enabled) return
    api({
      url: '/api2/teacher/list-prices',
      method: 'POST',
      data: { locale: 'en' },
    })
      .then((res) => setAnnualPrices(res.data.prices))
      .catch((err) => console.error('list-prices failed', err))
  }, [enabled])

  useEffect(() => {
    if (!enabled || !withSprint) return
    api({
      url: '/api2/teacher/list-prices-sprint',
      method: 'POST',
      data: { locale: 'en' },
    })
      .then((res) => setSprintPrices(res.data.prices))
      .catch((err) => console.error('list-prices-sprint failed', err))
  }, [enabled, withSprint])

  return { annualPrices, sprintPrices }
}
